import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import SurrenderIcon from '../../HOME/SVG/SurrenderIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import { showLeaderboards, requestSurrender, requestResetStats, setRestart } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { setInit } from '../REDUX/actions';
import * as f from '../logic';

const Toolbar = props => {
  const handleSurrender = e => {
    props.hideOptions();

    if (canSurrender()) {
      if (props.over) {
        f.restart(props);
      } else {
        props.requestSurrender(true);
      }

      props.requestResetStats(false);
    }
  };

  const handleLeaders = () => {
    props.hideOptions();
    props.showLeaderboards();
  };

  const canSurrender = () => {
    return !props.blocked;
  };

  const xmax = windowSize().x;
  const margin = Math.max(5, Math.min(10, xmax / 100));

  const styles = {
    button: { marginLeft: margin, marginRight: margin },
  };

  return (
    <div className="toolbar">
      <span className={`toolbar-button ${canSurrender(props) ? '' : 'toolbar-button-disabled'}`} style={styles.button} onClick={handleSurrender}>
        {props.over ? <RestartIcon width="36" /> : <SurrenderIcon width="36" />}
      </span>
      <span className="toolbar-button" style={styles.button} onClick={handleLeaders}>
        <TrophyIcon width="36" />
      </span>
      <span className="toolbar-button" style={styles.button} onClick={props.onClickOptions}>
        <OptionsIcon width="36" id="options-button" />
      </span>
    </div>
  );
};

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender, showLeaderboards, setInit, setRestart }
)(Toolbar);
